module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Devices/Cassete-341fcd33581e9f612ee967e05c794ae6.svg";